var OrderBundleBenefit = /*@__PURE__*/ (function () {
    function OrderBundleBenefit() {
        this.errors = [];
    }
    OrderBundleBenefit.prototype.setId = function (id) {
        this.id = id;
        return this;
    };
    OrderBundleBenefit.prototype.getId = function () {
        return this.id;
    };
    OrderBundleBenefit.prototype.setName = function (name) {
        this.nam = name;
        return this;
    };
    OrderBundleBenefit.prototype.getName = function () {
        return this.nam;
    };
    OrderBundleBenefit.prototype.setPrice = function (price) {
        this.prc = price;
        return this;
    };
    OrderBundleBenefit.prototype.getPrice = function () {
        return this.prc;
    };
    OrderBundleBenefit.prototype.setRec = function (rec) {
        this.rec = rec;
        return this;
    };
    OrderBundleBenefit.prototype.getRec = function () {
        return this.rec;
    };
    OrderBundleBenefit.prototype.setValid = function (valid) {
        this.valid = valid;
        return this;
    };
    OrderBundleBenefit.prototype.getValid = function () {
        return this.valid;
    };
    OrderBundleBenefit.prototype.addError = function (error) {
        this.errors.push(error);
        return this;
    };
    OrderBundleBenefit.prototype.getErrors = function () {
        return this.errors;
    };
    return OrderBundleBenefit;
}());
export { OrderBundleBenefit };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.bundle-benefit.ts
// module id = null
// module chunks = 